import homeWizardService from '../../../services/HomeWizardService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'PowerUsageFetcher';

/**
 * Raw I/O for power usage summaries — no cache, no state.
 */
class PowerUsageFetcher extends CoreBase {
    _name = _name;

    /**
     * @param {number} start - epoch ms
     * @param {number} end - epoch ms
     * @returns {Promise<object[]>}
     */
    fetch = async (start, end) => {
        try {
            // const res = await homeWizardService.getUsageSummaries(start, end);

            const res = await homeWizardService.getDayUsages(start, end);

            return res?.data?.items ?? [];
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const powerUsageFetcher = new PowerUsageFetcher();
export default powerUsageFetcher;
